import { useGetVehiclesQuery, Vehicle } from "../graphql/generated/graphql";
import {
  DRIVETRAIN_KEYS,
  FUEL_KEYS,
  TRANSMISSION_KEYS,
} from "../utils/constants";
import GoToWatchlistCard from "./GoToWatchlistCard";
import Grid from "./Grid";

function getVariables(vehicle: Vehicle) {
  const { year, category, drivetrain, transmission, fuel } = vehicle;
  return {
    limit: 15,
    filters: {
      yearMin: year - 5,
      yearMax: year + 5,
      category: [category],
      // We generate different set of filters depending on the vehicle characteristics. i.e: people may be interested in both electric and hybrids, but people looking for 4x4 only want to see 4x4
      drivetrain:
        drivetrain === DRIVETRAIN_KEYS["4WD"]
          ? [drivetrain]
          : Object.values(DRIVETRAIN_KEYS),
      transmission:
        transmission === TRANSMISSION_KEYS.AUTOMATIC
          ? [transmission]
          : Object.values(TRANSMISSION_KEYS), //[transmission],
      fuel:
        fuel === FUEL_KEYS.ELECTRIC || fuel === FUEL_KEYS.HYBRID
          ? [FUEL_KEYS.ELECTRIC, FUEL_KEYS.HYBRID]
          : Object.values(FUEL_KEYS),
    },
  };
}

export default function SimilarVehiclesGrid({ vehicle }: { vehicle: Vehicle }) {
  const variables = getVariables(vehicle);
  const { data, loading } = useGetVehiclesQuery({
    variables,
  });

  const { getVehicles } = data || {};
  const { data: vehicles, meta } = getVehicles || {};

  const [similarVehiclesBySameSeller, otherSimilarVehicles] = [
    vehicles?.filter(
      (v) => v.user._id === vehicle.user._id && v._id !== vehicle._id
    ) || [],
    vehicles?.filter((v) => v.user._id !== vehicle.user._id) || [],
  ];

  const similarVehicles = [
    ...similarVehiclesBySameSeller,
    ...otherSimilarVehicles,
  ];

  return (
    <Grid
      items={similarVehicles as Vehicle[]}
      currentVehicleSeller={vehicle.user._id}
      loading={loading}
      title="Vehículos similares"
      limit={15}
      // LastElement={() => (
      //   <GoToWatchlistCard
      //     pathname="/autosusados"
      //     query={variables.filters}
      //     icon="list"
      //     label="Ver todos"
      //   />
      // )}
    />
  );
}
